import api from "./apiConfig";

export const REGISTER_ARCHIVO_PERMANTENTE = async (propertieId, files) => {
	try {
        const formData = new FormData();
        formData.append("propertieId", propertieId);

        if (files.escritura) formData.append("escritura", files.escritura);
		if (files.comprobante_domicilio) formData.append("comprobante_domicilio", files.comprobante_domicilio);
		if (files.predial) formData.append("predial", files.predial);
		if (files.seguro) formData.append("seguro", files.seguro);
		if (files.contrato_luz) formData.append("contrato_luz", files.contrato_luz);
		if (files.contrato_agua) formData.append("contrato_agua", files.contrato_agua);

		const response = await api.post("/documentation", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const REGISTER_HIPOTECA = async (propertieId, files, values) => {
	try {
        const formData = new FormData();
        formData.append("propertieId", propertieId);

        if (values.banco) formData.append("banco", values.banco);
		if (values.titular_hipoteca) formData.append("titular_hipoteca", values.titular_hipoteca);
		if (values.pago_mensual) formData.append("pago_mensual", values.pago_mensual);
		if (values.start_date) formData.append("start_date", values.start_date);
		if (values.end_date) formData.append("end_date", values.end_date);

        if (files.compra_venta) formData.append("compra_venta", files.compra_venta);
		if (files.amortizacion) formData.append("amortizacion", files.amortizacion);
		if (values.seguro_mortgage) formData.append("seguro_mortgage", values.seguro_mortgage);

		const response = await api.post("/mortgages", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const REGISTER_RENTA = async (propertieId, files, values) => {
	try {
        const formData = new FormData();
        formData.append("propertieId", propertieId);
		formData.append("userId", values.userId);
		formData.append("datos_facturacion", values.datos_facturacion);
		formData.append("date_start", values.date_start);
		formData.append("date_end", values.date_end);
		formData.append("monto", values.monto);
		formData.append("isActive", true);
		formData.append("isAval", values.isAval);
		formData.append("iva", values.iva);
		formData.append("subtotal", values.subtotal);

        Object.entries(files).forEach(([key, file]) => {
            if (file) {
                formData.append(key, file);
            }
        });
		const response = await api.post("/rent", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_ARCHIVO_PERMAMENTE = async (id) => {
	try {
		const response = await api.get(`/documentation/propertie/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener el archivo permanente:", error);
		throw error;
	}
};

export const GET_HIPOTECA = async (id) => {
	try {
		const response = await api.get(`/mortgage/propertie/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener la hipoteca:", error);
		throw error;
	}
};

export const GET_RENTA_ARCHIVOS = async (id) => {
	try {
		const response = await api.get(`/rent/propertie/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener el archivo permanente:", error);
		throw error;
	}
};

export const GET_MANTENIMIENTO_BY_PROPERTIE = async (id) => {
	try {
		const response = await api.get(`/incidentLog/propertie/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener el archivo permanente:", error);
		throw error;
	}
};

export const GET_QUEJAS_REPORTES = async (id) => {
	try {
		const response = await api.get(`/incidentLog/propertie/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener el archivo permanente:", error);
		throw error;
	}
};

export const GET_DEBIT = async (id) => {
	try {
		const response = await api.get(`/documentation/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener el archivo permanente:", error);
		throw error;
	}
};

export const UPDATE_ARCHIVO_PERMAMENTE = async (id, files = {}) => {
	try {
		const formData = new FormData();

		if (files.escritura) formData.append("escritura", files.escritura);
		if (files.comprobante_domicilio) formData.append("comprobante_domicilio", files.comprobante_domicilio);
		if (files.predial) formData.append("predial", files.predial);
		if (files.seguro) formData.append("seguro", files.seguro);

		const response = await api.put(`/documentation/${id}`, formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});

		return response.data;
	} catch (error) {
		console.error("Error al actualizar archivo permanente:", error);
		throw error;
	}
};

export const UPDATE_HIPOTECA = async (id, files = {}, values = {}) => {
	try {
		const formData = new FormData();

		if (values.banco) formData.append("banco", values.banco);
		if (values.titular_hipoteca) formData.append("titular_hipoteca", values.titular_hipoteca);

		if (files.compra_venta) formData.append("compra_venta", files.compra_venta);
		if (files.amortizacion) formData.append("amortizacion", files.amortizacion);

		const response = await api.put(`/mortgage/${id}`, formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});

		return response.data;
	} catch (error) {
		console.error("Error al actualizar la hipoteca:", error);
		throw error;
	}
};

export const UPDATE_RENTA_ARCHIVOS = async (id, files = {}, values = {}) => {
	try {
		const formData = new FormData();

		formData.append("userId", values.userId);
		formData.append("datos_facturacion", values.datos_facturacion);
		formData.append("date_start", values.date_start);
		formData.append("date_end", values.date_end);
		formData.append("monto", values.monto);
		formData.append("isActive", String(values.isActive));
		formData.append("isAval", String(values.isAval));
		formData.append("iva", values.iva);
		formData.append("subtotal", values.subtotal);

		if (files.contrato_renta) formData.append("contrato_renta", files.contrato_renta);
		if (files.ine_inquilino) formData.append("ine_inquilino", files.ine_inquilino);
		if (files.poliza_aval) formData.append("poliza_aval", files.poliza_aval);

		const response = await api.put(`/rent/${id}`, formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});

		return response.data;
	} catch (error) {
		console.error("Error al actualizar archivos renta:", error);
		throw error;
	}
};

export const UPDATE_QUEJAS_REPORTES = async (id) => {
	try {
		const response = await api.get(`/documentation/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener el archivo permanente:", error);
		throw error;
	}
};

export const UPDATE_DEBIT = async (id) => {
	try {
		const response = await api.get(`/documentation/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener el archivo permanente:", error);
		throw error;
	}
};

export const DELETE_RENTA = async (id) => {
	try {
		const response = await api.delete(`/rent/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar la renta:", error);
		throw error;
	}
};

export const DELETE_HIPOTECA = async (id) => {
	try {
		const response = await api.delete(`/mortgage/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar la hipoteca:", error);
		throw error;
	}
};

export const VIEW_FILE = async (s3Key) => {
	try {
		const response = await api.post("/download-url", s3Key);
		return response.data;
	} catch (error) {
		console.error("Error al obtener el link:", error);
		throw error;
	}
};